import { useState } from "react";

import { ReactComponent as ArrowIcon } from "@assets/images/icons/angle-right-orange.svg";
import { ReactComponent as MinusIcon } from "@assets/images/icons/minus.svg";
import { ReactComponent as PlusIcon } from "@assets/images/icons/plus.svg";

import "./CopytradeFAQ.sass";

const questions = [
  {
    question: "How can I apply to become a lead trader?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
  {
    question: "How does copy trading work?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
  {
    question: "What are the requirements to become a trader?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
  {
    question: "What are the requirements to become a follower?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
  {
    question: "How do I choose the right trader?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
  {
    question: "What copy trading modes are available?",
    answer:
      "Yes, totally! The Basic plan is free. You can have unlimited personal files and file viewers. Maximum 1 team project can be created with 2 team files and 2 editors. You also have access to the Spline Library and can publish your scenes with a Spline logo.",
  },
];

const CopytradeFAQItem = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="copytrade-faq__question"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="copytrade-faq__question-wrapper">
        <h4 className="copytrade-faq__question-title">{question}</h4>

        {isExpanded ? <MinusIcon /> : <PlusIcon />}
      </div>

      <p
        className={`copytrade-faq__question-answer ${
          isExpanded ? "copytrade-faq__question-answer--visible" : ""
        }`}
      >
        {answer}
      </p>
    </div>
  );
};

export const CopytradeFAQ = () => {
  return (
    <div className="copytrade-faq">
      <div className="copytrade-faq__info">
        <h3 className="copytrade-faq__info-title">FAQ</h3>

        <a href="" className="copytrade-faq__info-link">
          Copytrading Guide
          <ArrowIcon />
        </a>
      </div>

      <div className="copytrade-faq__questions">
        {questions.map((question) => (
          <CopytradeFAQItem
            key={question.question}
            question={question.question}
            answer={question.answer}
          />
        ))}
      </div>
    </div>
  );
};
